// extracted by mini-css-extract-plugin
export default {"image":"e5-z","loaded":"f5-z"};